import { Grid } from "@mui/material"
import { CustomTable } from "../../../../../../components"
import { DrawerDataProps } from "./types"
import { UserScheduleConfig } from "../../userScheduleConfig"

const DrawerData = (props: DrawerDataProps) => {
    return (
        <Grid container spacing={4}>
            <Grid item xs={/* !!props.userSelectes?.id ? 7.5 : */ 12}>
                <CustomTable
                    ref={props.refTable}
                    disabledChecks={props.disabledChecks}
                    dontRefresh
                    tableChecks
                    defaultChecks={props.selectSchedule ?? []}
                    onClick={props.handleSelect}
                    column={props.columns}
                    row={props.rows ?? []}
                    selected={-1}
                />
            </Grid>

            <UserScheduleConfig
                data={props.data}
                disabled={props.diabledSaveSchedule}
                setErrors={props.setErrors}
                flag={props.flag}
                setFlag={props.setFlag}
                children={props.children}
                childrenRef={props.childrenRef}
                setChildren={props.setChildren}
                setData={props.setData}
                errors={props.errors}
                setStartDate={props.setStartDate}
                startDate={props.startDate}
                selectedDays={props.selectedDays}
                setSelectedDays={props.setSelectedDays}
                handleCloseScheduleUser={props.handleCloseScheduleUser}
                keepSaveSchedule={props.keepSaveSchedule}
                mimTimeZone={props.mimTimeZone}
                onChange={props.onChange}
                refRange={props.refRange}
                open={Boolean(props.userSelectes.id)}
                id={props.userSelectes.id}
                items={props.items}
                loadings={props.loadings}
                userSelectes={props.userSelectes}
            />
        </Grid>
    )
}

export { DrawerData }